//获得point2顶角的角度值
//point1传入起始点，point2传入圆心，point3传入结束点，可求得指针运动的夹角弧度
export function getAngle(point1, point2, point3) {
  const bb = (point2.y - point1.y) * (point2.y - point1.y) + (point2.x - point1.x) * (point2.x - point1.x);
  const aa = (point3.y - point1.y) * (point3.y - point1.y) + (point3.x - point1.x) * (point3.x - point1.x);
  const cc = (point3.y - point2.y) * (point3.y - point2.y) + (point3.x - point2.x) * (point3.x - point2.x);
  const cosa = (bb + cc - aa) / (2 * Math.sqrt(bb) * Math.sqrt(cc));
  return Math.acos(cosa) * (180 / Math.PI);
}

//通过面积量的方法来判断顺时针还是逆时针
//point1传入圆心，point2传入起始点，point3传入终点
export function duration(point1, point2, point3) {
  const sp = (point1.x - point3.x) * (point2.y - point3.y) - (point1.y - point3.y) * (point2.x - point3.x);
  if (sp > 0) { //顺时针
    return 1
  } else if (sp < 0) { //逆时针
    return -1
  } else {
    return 0;
  }
}

export function browser(name) {
  const u = navigator.userAgent;
  const app = navigator.appVersion;
  let ver = app.match(/OS (\d+)_(\d+)_?(\d+)?/);
   ver = parseInt(ver[1], 10);
  const b = {
    mobile: !!u.match(/AppleWebKit.*Mobile.*/),
    overios11: ver >= 11,
    safari: u.indexOf("Safari") > -1
  };
  return b[name];
}

/* eslint-disable */
export function getParameterByName(name) {
  name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(window.location.search);
  return results == null ? '' : decodeURIComponent(results[1]);
}
